import React from 'react';
import OrderDetails from './OrderDetails';

function Order() {
  return <OrderDetails from="cs" />;
}

export default Order;
